var React = require('react');

function Person (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M16 7.867c1 0 1.925.533 2.425 1.4.5.866.5 1.933 0 2.8-.5.866-1.425 1.4-2.425 1.4-1.546 0-2.8-1.254-2.8-2.8 0-1.547 1.254-2.8 2.8-2.8m0 12c3.96 0 8.133 1.946 8.133 2.8v1.466H7.867v-1.466c0-.854 4.173-2.8 8.133-2.8m0-14.534c-2.947 0-5.333 2.387-5.333 5.334C10.667 13.613 13.053 16 16 16s5.333-2.387 5.333-5.333c0-2.947-2.386-5.334-5.333-5.334zm0 12c-3.56 0-10.667 1.787-10.667 5.334v4h21.334v-4c0-3.547-7.107-5.334-10.667-5.334z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H32V32H0z","key":1})]));
}

Person.defaultProps = {"width":"24","height":"24","viewBox":"0 0 32 32"};

module.exports = Person;

Person.default = Person;
